import React, { useCallback } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { useFileUpdate, useUpload } from '../rc-upload/';
import { CloseSmall, Loading, ViewList as View } from './../../../common/icons';
export function TextFileListItem(props) {
  var file = props.file,
      domRef = props.domRef,
      iconRender = props.iconRender;
  var fileUpload = useUpload();
  var textFileListItemCls = usePrefixCls('upload-file-list-text-item');
  var textFileListItemNameCls = usePrefixCls('upload-file-list-text-item-name');
  var textFileListItemCloseCls = usePrefixCls('upload-file-list-text-item-close');
  var textFileListItemContentCls = usePrefixCls('upload-file-list-text-item-content');
  var loadingCls = usePrefixCls('upload-file-list-text-item-loading');
  var textFileListItemErrorCls = usePrefixCls('upload-file-list-text-item-error');
  var linkCls = classnames(usePrefixCls('link'), usePrefixCls('upload-file-list-text-item-link'));
  var removeFile = useCallback(function () {
    fileUpload.removeFileById(file.id);
  }, []);
  useFileUpdate(file.id);
  return React.createElement("li", {
    className: textFileListItemCls,
    "data-status": file.fileStatus,
    ref: domRef
  }, React.createElement("div", {
    className: textFileListItemContentCls
  }, iconRender ? iconRender(file) : file.fileStatus === "LOADING" ? React.createElement(Loading, {
    className: loadingCls
  }) : React.createElement(View, null), file.href ? React.createElement("a", {
    className: linkCls,
    href: file.href,
    target: "_blank",
    rel: "noreferrer"
  }, file.name) : React.createElement("span", {
    className: textFileListItemNameCls,
    title: file.name
  }, file.name), React.createElement(CloseSmall, {
    className: textFileListItemCloseCls,
    onClick: removeFile
  })), file.fileStatus === "FAIL" && React.createElement("div", {
    className: textFileListItemErrorCls
  }, file.errmsg));
}